import React, { Fragment } from "react";
import { connect } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import DriverProfile from "../components/DriverProfile";
import EditDriverProfile from "../components/EditDriverProfile";
import { getDriverProfile } from "../actions/driverAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

class DriverContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getDriverProfile(this.props.match.params.id);
  }
  render() {
    const { loading, driver } = this.props.driver;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            className="mt-2"
            id="left-tabs-example"
            defaultActiveKey="profile"
            mountOnEnter
            unmountOnExit
          >
            <Row>
              <Col sm={2} className="pt-5">
                <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="profile">Driver Profile</Nav.Link>
                  </Nav.Item>
                  <LinkContainer exact to="/edit_profile/:id">
                    <Nav.Item>
                      <Nav.Link eventKey="edit_profile">
                        Edit Driver Profile
                      </Nav.Link>
                    </Nav.Item>
                  </LinkContainer>
                </Nav>
              </Col>
              <Col sm={10}>
                <div className="container-fluid">
                  <Tab.Content>
                    <Tab.Pane eventKey="profile">
                      <DriverProfile driver={driver} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="edit_profile">
                      <EditDriverProfile driver={driver} />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ driver }) => ({
  driver: driver,
});
const mapDispatchToProps = (dispatch) => ({
  getDriverProfile: (driver) => dispatch(getDriverProfile(driver)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DriverContainer);
